"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Offer = void 0;
const with_class_name_1 = require("./with-class-name");
class Offer extends with_class_name_1.WithClassName {
    constructor() {
        super(...arguments);
        this.code = '';
    }
}
exports.Offer = Offer;



//////////////////
// WEBPACK FOOTER
// ./~/rules-config/lib/offer.js
// module id = 1257
// module chunks = 0